import { useCallback, useReducer } from "react";

const LIMIT = 200;
const MERGE_MS = 1000;

// Historique local annuler / rétablir. Les frappes successives dans un même champ
// (même clé, moins d'une seconde d'écart) forment une seule étape d'annulation.
const reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return { past: [], present: action.document, future: [], lastKey: null, lastAt: 0 };
    case "apply": {
      const next = action.updater(state.present);
      if (next === state.present) return state;
      const merge = action.key && action.key === state.lastKey && action.at - state.lastAt < MERGE_MS;
      return {
        past: merge ? state.past : [...state.past, state.present].slice(-LIMIT),
        present: next,
        future: [],
        lastKey: action.key || null,
        lastAt: action.at,
      };
    }
    case "undo": {
      if (!state.past.length) return state;
      const previous = state.past[state.past.length - 1];
      return { past: state.past.slice(0, -1), present: previous, future: [state.present, ...state.future],
        lastKey: null, lastAt: 0 };
    }
    case "redo": {
      if (!state.future.length) return state;
      const [next, ...rest] = state.future;
      return { past: [...state.past, state.present], present: next, future: rest, lastKey: null, lastAt: 0 };
    }
    default:
      return state;
  }
};

export const useUndoableDocument = (initial = null) => {
  const [state, dispatch] = useReducer(reducer, { past: [], present: initial, future: [], lastKey: null, lastAt: 0 });
  const apply = useCallback((updater, key) => dispatch({ type: "apply", updater, key, at: Date.now() }), []);
  const reset = useCallback((document) => dispatch({ type: "reset", document }), []);
  const undo = useCallback(() => dispatch({ type: "undo" }), []);
  const redo = useCallback(() => dispatch({ type: "redo" }), []);
  return {
    document: state.present, apply, reset, undo, redo,
    canUndo: state.past.length > 0, canRedo: state.future.length > 0,
  };
};
